import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

import { PromoParagraph1, PromoTextWithStyleHeading1, PromoTextWithStyleHeading2 } from '.';

const TextWrapper = styled.div<{ $lastIndent?: boolean }>`
    display: block;
    
    ${PromoTextWithStyleHeading1} {
        margin-bottom: 16px;
    
        @media (min-width: ${wideBreakpoints.mobile}) {
            margin-bottom: 24px;
        }
    }
    
    ${PromoTextWithStyleHeading2} {
        margin-bottom: 8px;
        
        @media (min-width: ${wideBreakpoints.mobile}) {
            margin-bottom: 16px;
        }
    }
    
    ${PromoParagraph1} {
        ${({ $lastIndent = true }) => $lastIndent
            ? css`
              margin-bottom: 16px;
            `
            : ''
        }
    }
`;

export default TextWrapper;
